// @ts-check
/// <reference lib="dom" />
/// <reference lib="es2020" />

/**
 * @typedef {import("@hotwired/stimulus").Controller} StimulusController
 */

/**
 * @typedef {Object} LoadingControllerProperties
 * @property {HTMLButtonElement | HTMLInputElement} element
 * @property {boolean} hasLoadingIconTarget
 * @property {HTMLElement} loadingIconTarget
 * @property {boolean} [hasTextContentTarget]
 * @property {HTMLElement} [textContentTarget]
 */

/**
 * @typedef {StimulusController & LoadingControllerProperties} LoadingController
 */

/**
 * @this {LoadingController}
 */
function startLoading() {
  if (this.hasTextContentTarget) {
    this.textContentTarget.classList.add('elv-invisible');
  }
  this.loadingIconTarget.classList.remove('elv-hidden');
}

/**
 * @this {LoadingController}
 */
function stopLoading() {
  if (!this.hasLoadingIconTarget) {
    return;
  }

  this.textContentTarget.classList.remove('elv-invisible');
  this.loadingIconTarget.classList.add('elv-hidden');
}

/**
 * Adds loading functionality to a Stimulus controller
 * @param {StimulusController} controller - The Stimulus controller to enhance with loading functionality
 */
export const useLoading = (controller) => {
  Object.assign(controller, {
    startLoading,
    stopLoading
  });
};
